import React from "react";
import T from "prop-types";
import ActionDropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import Download from "./Download";

export default function Actions({ url }) {
  return (
    <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
      <ActionDropDown menuClass="dropdown-menu-right">
        <Download url={url} />
      </ActionDropDown>
    </div>
  );
}

Actions.propTypes = {
  url: T.string.isRequired,
  shipment: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/MistakeShipments/components/Detail/Actions/Actions.jsx